import React from 'react';
import { Helmet } from 'react-helmet';
import { Briefcase, Code, Smartphone, TrendingUp } from "lucide-react";

const SalesforceCompetencies = () => {
  return (
    <section className="tech-services-section">
      <Helmet>
        <title>Salesforce Competencies | Pravisht Digital</title>
        <meta
          name="description"
          content="Pravisht offers comprehensive Salesforce services including Sales Cloud, Service Cloud, Marketing Cloud, Einstein Analytics, and more. Unlock your CRM potential."
        />
        <meta
          name="keywords"
          content="Salesforce, Sales Cloud, Service Cloud, Marketing Cloud, Einstein Analytics, Salesforce Platform, CRM, Pravisht Digital"
        />
        <meta property="og:title" content="Salesforce Competencies | Pravisht Digital" />
        <meta
          property="og:description"
          content="Comprehensive Salesforce services by Pravisht. Expert implementation of Sales Cloud, Service Cloud, Marketing Cloud, and advanced Salesforce solutions."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/testing_pravisht.jpg" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>

      <div className="breadcrumb">
        <a href="/" className="mx-1">Home</a> &gt; <span className="mx-1">Salesforce Competencies</span>
      </div>

      <div className="about-heading-section">
        <h1>Salesforce Competencies</h1>
        <p>
          As a digital transformation partner, Pravisht offers end-to-end Salesforce services that unlock the true power of CRM, automation, and cloud platforms for your enterprise. Our expertise spans across the Salesforce ecosystem—from core cloud solutions to intelligent analytics and industry-specific applications.
        </p>
      </div>

      <div className="about-image-fullscreen">
        <img src="/testing_pravisht.jpg" alt="Salesforce Services by Pravisht" />
      </div>

      <div className="core-offerings">
        <div className="how-we-help__content">
          <p className="how-we-help__description services-desc">Our Services</p>
          <h1 className="how-we-help__title">Our Salesforce Solution Stack</h1>
          <hr className="portfolio-horizontalline" />
        </div>

        <div className="offerings-grid">
          <div className="offering-card app-dev-card">
            <h4>☁️ Sales Cloud</h4>
            <p>Streamline sales processes, manage pipelines efficiently, and boost lead conversions with powerful sales automation tools.</p>
          </div>

          <div className="offering-card consulting-card">
            <h4>☁️ Service Cloud</h4>
            <p>Deliver personalised and connected customer service experiences across multiple channels.</p>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>☁️ Marketing Cloud</h4>
            <p>Drive targeted customer engagement with AI-powered campaigns and journey mapping.</p>
          </div>

          <div className="offering-card automation-card">
            <h4>☁️ Salesforce Maps</h4>
            <p>Location intelligence for sales teams to plan territories and routes more effectively.</p>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>☁️ Einstein Analytics</h4>
            <p>AI-powered insights to make smarter decisions with predictive modelling and dashboards.</p>
          </div>

          <div className="offering-card consulting-card">
            <h4>☁️ Experience Cloud</h4>
            <p>Enable partners, customers, and employees to collaborate through tailored digital experiences.</p>
          </div>

          <div className="offering-card app-dev-card">
            <h4>☁️ Work.com</h4>
            <p>Solutions for employee wellness, shift management, and workplace command centres.</p>
          </div>

          <div className="offering-card automation-card">
            <h4>☁️ Field Service Lightning</h4>
            <p>Optimise field operations with real-time workforce scheduling and mobile-first service support.</p>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>☁️ CPQ (Configure, Price, Quote)</h4>
            <p>Accelerate quote-to-cash cycles with automated product configuration and pricing.</p>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>☁️ Pardot</h4>
            <p>B2B marketing automation to fuel smarter lead generation and nurturing.</p>
          </div>

          <div className="offering-card consulting-card">
            <h4>☁️ Salesforce Platform (1 &amp; Lightning)</h4>
            <p>Build custom applications that are secure, scalable, and integrated natively within the Salesforce ecosystem.</p>
          </div>
        </div>
      </div>

      <div className="engagement-layers-and-why-choose" style={{ backgroundColor: '#f1f4f3', marginBottom: '60px' }}>
        
          <h3 className="section-subtitle">Why Choose Pravisht for Salesforce</h3>
          <p>Our Salesforce-first delivery model ensures enterprise-wide impact and lasting results:</p>
       
        <div className="bottom-sections-grid">
          <div className="how-we-help__cards">
            {[
              { icon: <Briefcase size={40} />, title: "Domain Knowledge", desc: "Industry-specific solutions mapped to Salesforce capabilities" },
              { icon: <Smartphone size={40} />, title: "Certified Experts", desc: "Implementation by Salesforce-certified professionals" },
              { icon: <Code size={40} />, title: "Platform Extensibility", desc: "Tailored apps and integrations via Salesforce Platform" },
              { icon: <TrendingUp size={40} />, title: "Business Alignment", desc: "Strategic Salesforce adoption aligned to goals" }
            ].map((card, i) => (
              <div className="how-we-help__card" key={i} style={{ height: '190px', cursor: 'default' }}>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SalesforceCompetencies;
